import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Row, Col, Modal } from "react-bootstrap";
import { ButtonStandard } from '../../components'


import './SubcontractorToProviderModal.scss';

import messages from "../../assets/i18n";

function SubcontractorToProviderModal(props) {

	const lang = useSelector(state => state.language.name);
	const pageMessages = messages[lang].providerDetailsPage;
	const dispatch = useDispatch();

	const subcontractorList = useSelector(state => state.subcontractor.fetchedSubcontractorsNotLinkedProvider.buscarSubcontratadoNaoVinculadoAoFornecedor);
	const selectedProvider = useSelector(state => state.provider.selectedProvider);
	const isLoadingProviderUpdate = useSelector(state => state.provider.isLoadingProviderUpdate);

	const [validated, setValidated] = useState(false);

	const [formFields, setFormFields] = useState({
		subcontratado: '-1'
	});

	const handleSubmit = (event) => {
		let subcontratado = subcontractorList.filter(i => i.id === parseInt(formFields.subcontratado))[0]
		const form = event.currentTarget;

		event.preventDefault();
		event.stopPropagation();

		if (form.checkValidity()) {
			dispatch({
				type: 'ADD_PROVIDER_SUBCONTRACTOR',
				payload: { fornecedorId: selectedProvider.data.id, subcontratadoId: subcontratado.id }
			})
		}

		setValidated(true);
		props.onHide();
	};

	return (
		<Modal
			{...props}
			aria-labelledby="contained-modal-title-vcenter"
			className="provider-to-subcontractor-modal"
			centered
		>
			<Form noValidate validated={validated} className="px-3" onSubmit={handleSubmit}>
				<Modal.Header className="text-center" closeButton>
					<Modal.Title className="w-100">{pageMessages.addSubcontratado}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Form.Group as={Col} xs={12} className="mt-1">
							<Form.Label className="text-2">{pageMessages.subcontratado}</Form.Label>

							<Form.Control
								required
								as="select"
								className="text-2 border-radius-full"
								type="text"
								value={formFields.subcontratado}
								disabled={false}
								onChange={event => setFormFields(
									{ ...formFields, subcontratado: event.target.value },
								)}
							>
								{
									subcontractorList.map(value => (
										<option key={value.id} value={value.id}>{value.nomeFantasia}</option>
									))
								}
							</Form.Control>

							<Form.Control.Feedback type="invalid">
								{messages[lang].requiredField}
							</Form.Control.Feedback>
						</Form.Group>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<ButtonStandard
						id="norm_save_button"
						type="submit"
						text={messages[lang].save}
						textClass="text-2"
						disabled={formFields.subcontratado === '-1'}
						isLoading={isLoadingProviderUpdate}
						className="btn btn-primary btn-standard px-3 py-2 btn-primary btn-rounded" />
				</Modal.Footer>
			</Form>
		</Modal>
	)
}

export default SubcontractorToProviderModal;